document.addEventListener( 'DOMContentLoaded', function () {
	jQuery( '.slider-wrapper' ).slick( {
		dots: false,
		infinite: false,
		arrows: false,
		slidesToShow: 3,
		centerMode: false,
		variableWidth: true,
		swipe: true,
		responsive: [
			{
				breakpoint: 768, // Adjust this value based on your design
				settings: {
					slidesToShow: 1, // Show 1 slide on mobile
				}
			}
		]
	} );
} );
